export default "__VITE_ASSET__e15854ef__"